import { MemoryHistory } from 'history';

/**
 * Clear history to prevent backwards nav. This only works for MemoryHistory.
 *
 * Note we have to coerce the argument to type MemoryHistory because react-router only exposes
 * history object as type History.
 */
export function clearMemoryHistory(history: MemoryHistory) {
  if (history) {
    history.entries = [];
    history.length = 0;
    history.index = -1;
  }
}

/**
 * Truncate history to latest entry to prevent backwards nav. This only works for MemoryHistory.
 * Use this insated of clearMemoryHistory if the next history action is a replace, not a push,
 * because the index -1 will cause replace to set the new entry at index = -1
 *
 * Note we have to coerce the argument to type MemoryHistory because react-router only exposes
 * history object as type History.
 */
export function truncateMemoryHistory(history: MemoryHistory) {
  if (history) {
    history.entries = history.entries.slice(-1);
    history.length = 1;
    history.index = 0;
  }
}
